import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import axios from "axios";
import fileDownload from "js-file-download";
import {
  errorNotification,
  successNotification
} from "../../utils/notifications";
import { TipoComision } from "../../types/ComisionAlcance";

const COMISION_ANUALIDAD_BASE_URL = "/api/comisiones-anualidad";

export const postCargaMetas = (
  formData: FormData,
  confirmar: boolean,
  periodo: string
): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_CARGA_METAS,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/meta-carga`,
      formData,
      {
        withCredentials: true,
        params: { confirmar, periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getMetas = (): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_METAS,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/meta-carga`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getComisionAlcanceAnualidadByTipos = (): IAction => {
  const tiposComision = [
    TipoComision.ASESOR_ANUALIDAD,
    TipoComision.GERENTE_REGIONAL_ANUALIDAD,
    TipoComision.ASESOR_ANUALIDAD_BONO,
    TipoComision.CHATER_ANUALIDAD,
    TipoComision.CHATER_ANUALIDAD_BONO,
    TipoComision.SUPERVISOR_ANUALIDAD,
    TipoComision.SUPERVISOR_ANUALIDAD_BONO
  ];

  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_ALCANCES,
    payload: axios.get(
      `${constants.BASE_URL}/api/comisiones-membresia/alcance/tipos-comision`,
      {
        withCredentials: true,
        params: { tipos: tiposComision.join(",") }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearSnapshot = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_ANUALIDAD_SNAPSHOT,
    payload: true
  };
};

export const getSnapshotByFolioFactura = (
  folioFactura: string,
  page: number,
  size: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_FOLIO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/facturas`,
      {
        withCredentials: true,
        params: { folioFactura, page, size }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getSnapshotByPeriodo = (
  periodo: string,
  idClub?: number,
  soloContactCenter?: boolean,
  conCambios?: boolean,
  evaluadorModifico?: boolean,
  page?: number,
  size?: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/periodos`,
      {
        withCredentials: true,
        params: {
          periodo,
          idClub,
          soloContactCenter,
          conCambios,
          evaluadorModifico,
          page,
          size
        }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getSnapshotByAsesor = (
  periodo: string,
  idVendedor: number,
  page: number,
  size: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_SNAPSHOT_BY_ASESOR,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/asesores`,
      {
        withCredentials: true,
        params: { periodo, idVendedor, page, size }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

/**
 * REPORTE GENERAL DE VENDEDORES — Action Redux
 * Pantalla: /reportes/reporte-general-vendedor
 *
 * Params: periodo (YYYY-MM-01), idVendedor (opcional; permiso 57000), page, size.
 * Type: GET_COMISION_ANUALIDAD_REPORTE_GENERAL_VENDEDOR
 * BFF: GET /api/comisiones-anualidad/snapshot/reporte-general-vendedor
 *   → MS: GET /v1/anualidad-snapshot/reporte-general-vendedor
 */
export const getReporteGeneralVendedor = (
  periodo: string,
  idVendedor: number | null | undefined,
  page: number,
  size: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_REPORTE_GENERAL_VENDEDOR,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/reporte-general-vendedor`,
      {
        withCredentials: true,
        params: {
          periodo,
          // Solo user_id válido; evita mandar NaN/employeeNumber inválido
          ...(idVendedor != null && !Number.isNaN(Number(idVendedor))
            ? { idVendedor: Number(idVendedor) }
            : {}),
          page,
          size
        }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postSnapshotByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_SNAPSHOT_BY_PERIODO,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/periodos`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putSnapshotEvaluacion = (
  idCotizacionItem: number,
  actualizacion: any
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/evaluacion/${idCotizacionItem}`,
      actualizacion,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteSnapshotEvaluacion = (idCotizacionItem: number): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_ANUALIDAD_SNAPSHOT_EVALUACION,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/descartar-cambios/${idCotizacionItem}`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const clearResumen = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_ANUALIDAD_RESUMEN,
    payload: true
  };
};

export const getResumenByPeriodo = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/periodos/${periodo}/resumen`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getResumenByPeriodoAndIdClub = (
  periodo: string,
  idClub: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_RESUMEN_BY_PERIODO_CLUB,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/periodos/${periodo}/clubes/${idClub}/resumen`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putCambiarVendedor = (
  idCotizacionItem: number,
  request: any
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/cambiar-vendedor/${idCotizacionItem}`,
      request,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const putCambiarPeriodo = (
  idCotizacionItem: number,
  request: any
): IAction => {
  return {
    type: actionTypes.PUT_COMISION_ANUALIDAD_CAMBIAR_PERIODO,
    payload: axios.put(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/cambiar-periodo/${idCotizacionItem}`,
      request,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCambiarVendedorMasivo = (
  formData: FormData,
  confirmar: boolean
): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_CAMBIAR_VENDEDOR_MASIVO,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/cambiar-vendedor-masivo`,
      formData,
      {
        withCredentials: true,
        params: { confirmar }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadSnapshotByFolioFactura = (
  folioFactura: string,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/facturas/descargar`,
      {
        withCredentials: true,
        params: { folioFactura }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `Anualidades.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const downloadSnapshotByPeriodo = (
  periodo: string,
  idClub: number,
  soloContactCenter: boolean,
  conCambios: boolean,
  evaluadorModifico: boolean,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/periodos/descargar`,
      {
        withCredentials: true,
        params: {
          periodo,
          idClub,
          soloContactCenter,
          conCambios,
          evaluadorModifico
        }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `Anualidades.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const downloadSnapshotByAsesor = (
  periodo: string,
  idVendedor: number,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/asesores/descargar`,
      {
        withCredentials: true,
        params: { periodo, idVendedor }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `Anualidades.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const getEstadoProceso = (periodo: string): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_PROCESO_ESTADO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularAlcancesContactCenter = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CC,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/calcular-alcances`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postPrecalculoContactCenter = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CC,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/precalculo`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularComisionesContactCenter = (
  periodo: string
): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CC,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/calcular-comisiones`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularAlcancesClub = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_ALCANCES_CLUB,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/calcular-alcances`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postPrecalculoClub = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_PROCESO_PRECALCULO_CLUB,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/precalculo`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularComisionesClub = (periodo: string): IAction => {
  return {
    type: actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_CLUB,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/calcular-comisiones`,
      null,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postCalcularComisionesSemestral = (
  periodo: string,
  metaChater?: number
): IAction => {
  return {
    type:
      actionTypes.POST_COMISION_ANUALIDAD_PROCESO_CALCULAR_COMISIONES_SEMESTRAL,
    payload: axios.post(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/semestral/calcular-comisiones`,
      { periodo, metaChater },
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadProyectoAnualidad = (periodo: string, callback: any) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proyectos/descargar`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `ResumenClub_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const downloadAlcancesContactCenter = (
  periodo: string,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/descargar-alcances`,
      {
        withCredentials: true,
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `AlcancesContactCenter_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de alcances");
      callback && callback(error);
    });
};

export const downloadPrecalculoContactCenter = (
  periodo: string,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/descargar-precalculo`,
      {
        withCredentials: true,
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `PrecalculoContactCenter_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de precálculo");
      callback && callback(error);
    });
};

export const downloadComisionesContactCenter = (
  periodo: string,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/descargar-comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `ComisionesContactCenter_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de comisiones");
      callback && callback(error);
    });
};

export const downloadAlcancesClub = (periodo: string, callback: any) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/descargar-alcances`,
      {
        withCredentials: true,
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `AlcancesClub_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de alcances");
      callback && callback(error);
    });
};

export const downloadPrecalculoClub = (periodo: string, callback: any) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/descargar-precalculo`,
      {
        withCredentials: true,
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `PrecalculoClub_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de precálculo");
      callback && callback(error);
    });
};

export const clearAnualidadProyecto = (): IAction => {
  return {
    type: actionTypes.CLEAR_COMISION_ANUALIDAD_PROYECTO,
    payload: true
  };
};

export const getProyectoByPeriodo = (
  periodo: string,
  alcancesActuales?: boolean
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_PROYECTO_BY_PERIODO,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proyectos`,
      {
        withCredentials: true,
        params: { periodo, alcancesActuales }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getProyectosOptions = (): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_PROYECTOS_OPTIONS,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proyectos/options`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const downloadComisionesClub = (periodo: string, callback: any) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/descargar-comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `ComisionesClub_${periodo}.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte de comisiones");
      callback && callback(error);
    });
};

export const downloadReporteSemestral = (periodo: string, callback: any) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/semestral/descargar-reporte`,
      {
        withCredentials: true,
        responseType: "blob",
        params: { periodo }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `Comisiones_Semestral_${periodo}.xlsx`);
      successNotification("Reporte descargado exitosamente");
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte semestral");
      callback && callback(error);
    });
};

export const getCalculoSemestralAceptable = (): IAction => {
  return {
    type:
      actionTypes.GET_COMISION_ANUALIDAD_PROCESO_CALCULO_SEMESTRAL_ACEPTABLE,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/semestral/calculo-aceptable`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirAlcancesContactCenter = (
  periodo: string
): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CC,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/revertir-alcances`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirPrecalculoContactCenter = (
  periodo: string
): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CC,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/revertir-precalculo`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirComisionesContactCenter = (
  periodo: string
): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CC,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/contact-center/revertir-comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirAlcancesClub = (periodo: string): IAction => {
  return {
    type: actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_ALCANCES_CLUB,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/revertir-alcances`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirPrecalculoClub = (periodo: string): IAction => {
  return {
    type:
      actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_PRECALCULO_CLUB,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/revertir-precalculo`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirComisionesClub = (periodo: string): IAction => {
  return {
    type:
      actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_CLUB,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/club/revertir-comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const deleteRevertirComisionesSemestral = (periodo: string): IAction => {
  return {
    type:
      actionTypes.DELETE_COMISION_ANUALIDAD_PROCESO_REVERTIR_COMISIONES_SEMESTRAL,
    payload: axios.delete(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/proceso/semestral/revertir-comisiones`,
      {
        withCredentials: true,
        params: { periodo }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

/**
 * Descarga CSV del reporte de anualidades de un líder comercial.
 */
export const downloadSnapshotByLiderClub = (
  periodo: string,
  idClub: number,
  idLider: number | undefined,
  soloContactCenter: boolean,
  conCambios: boolean,
  evaluadorModifico: boolean,
  callback: any
) => {
  axios
    .get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/lideres-comerciales/descargar`,
      {
        withCredentials: true,
        params: {
          periodo,
          idClub,
          ...(idLider != null ? { idLider } : {}),
          soloContactCenter,
          conCambios,
          evaluadorModifico
        }
      }
    )
    .then(({ data }) => {
      fileDownload(data, `AnualidadesLiderComercial.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

/**
 * Obtiene los clubes asignados a un líder comercial en un periodo específico.
 */
export const getClubesByLider = (
  periodo: string,
  idLider?: number
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_LIDER_CLUBES,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/lideres-comerciales/clubes`,
      {
        withCredentials: true,
        params: {
          periodo,
          ...(idLider != null ? { idLider } : {})
        }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

/**
 * Obtiene el reporte de anualidades de un líder comercial para un club específico.
 */
export const getReporteByLiderClub = (
  periodo: string,
  idClub: number,
  idLider?: number,
  soloContactCenter?: boolean,
  conCambios?: boolean,
  evaluadorModifico?: boolean
): IAction => {
  return {
    type: actionTypes.GET_COMISION_ANUALIDAD_LIDER_REPORTE,
    payload: axios.get(
      `${constants.BASE_URL}${COMISION_ANUALIDAD_BASE_URL}/snapshot/lideres-comerciales/reporte`,
      {
        withCredentials: true,
        params: {
          periodo,
          idClub,
          ...(idLider != null ? { idLider } : {}),
          soloContactCenter,
          conCambios,
          evaluadorModifico
        }
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};
